import styled, { css }  from 'styled-components';
import media from '~/utils/media';
import On from '../../assets/check_on.svg';

export const Container = styled.div`
  margin: 0 auto;
  color:white;
  background-color: #326CF9;
  width: 93.7%;
  display: flex;
  align-items: center;
  border-radius: 8px 8px 0px 0px;
  height: 48px;
  ${media.mobileLarge`
      height: 36px;
  `}

  ${media.mobileMid`
    height: 36px;
  `}

  ${media.mobileSmall`
    height: 36px;
  `}
  svg {
   cursor: pointer;
   ${({ isCheck }) => isCheck ? css`
        transform: rotate(-180deg);
        transition: transform 150ms ease;
      ` : css`
      transform: rotate(0deg);
      transition: transform 150ms ease;
    `}
    ${media.tabletSmall`
      width: 20px;
      height: 20px;
    `}

    ${media.mobileLarge`
      width: 20px;
      height: 20px;
    `}

    ${media.mobileMid`
      width: 20px;
      height: 20px;
    `}

    ${media.mobileSmall`
      width: 20px;
      height: 20px;
    `}
  }
  .checkbox-label {
    margin-right: 6px;
    margin-left: 5.8%;
    position: relative;
    height: 18px;
    display: flex;
    align-items: center;
    color: #484848;
    cursor: pointer;
    float: left;
    clear: both;
  }
  .svg-wrapper {
    width: 32px;
    height: 32px;
    background-color: inherit;
    border: none;
    ${media.tabletSmall`
      width: 20px;
      height: 20px;
    `}

    ${media.mobileLarge`
      width: 20px;
      height: 20px;
    `}

    ${media.mobileMid`
      width: 20px;
      height: 20px;
    `}

    ${media.mobileSmall`
      width: 20px;
      height: 20px;
    `}
  }
  // ie input x 버튼 삭제
  input::-ms-clear {
    display: none;
  }
  input[type='checkbox'] {
    margin: 0;
    border: 0;
    width: 0;
    height: 0;
    -webkit-appearance: none;
  }
  input[type='checkbox']:checked {
    margin: 0;
    border: 0;
    -webkit-appearance: none;
  }

  //공백을위해 존재함
  input[type='checkbox'] + span {
    width: 18px;
    height: 18px;
    margin-right: 8px;
    display: inline-block;
    flex-shrink: 0;

  }
  span + p {
  color: white;
  font-weight: 700;
  font-size: 14px;

  ${media.mobileLarge`
    font-size: 10px;
    
  `}

  ${media.mobileMid`
    font-size: 10px;
  `}

  ${media.mobileSmall`
    font-size: 10px;
  
  `}

  }
  // + 연산자를 통해 input태그옆의 span 태그에 접근할수있다.
  input[type='checkbox'] + span::before {
    content: '';
    width: 18px;
    height: 18px;
    position: absolute;
    top: 0;
    display: inline-table;
    border: 1px solid #b0b0b0;
    border-radius: 2px;
    box-sizing: border-box;
    background-color: white;
    cursor: pointer;
  }
  input[type='checkbox']:checked + span::before {
    content: '';
    width: 18px;
    height: 18px;
    display: inline-table;
    background-color: #008489;
    border: 0;
    border-radius: 2px;
    position: absolute;
    background-image: url(${On});
    background-repeat: no-repeat;
    background-position: center;
  }

`;

